import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Grid } from 'antd';
import { ContentFilters, ContentTopBar } from 'components';
import { MatrialDetailsModalView } from 'features/material-details/compoents/modal/matrial-details-view-modal';
import { useState } from 'react';
import { SideBarMenus } from 'routes/constants';
import { CompanyType } from 'types';
import { HasPermission } from 'utils/CheckPermissions';

import { MatrialDetailsViewFilterForm } from './material-filter-form';
import { MaterialDetailFilterFormValues } from './type';

const { useBreakpoint } = Grid;
type MatrialTopBarProps = {
  getInitialFilterValues: MaterialDetailFilterFormValues;
  handleFilter: (values: MaterialDetailFilterFormValues ) => void;
  matrialEditData: any;
  showAppUserModal: any;
  setShowAppUserModal: any;
  setmatrialEditData: any,
  onRefresh: () => void;
};

export const MatrialDetailsViewTopBar = ({
  getInitialFilterValues,
  handleFilter,
  showAppUserModal,
  setShowAppUserModal,
  matrialEditData,
  setmatrialEditData,
  onRefresh
}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';
  const screens = useBreakpoint();
  const [form] = Form.useForm();
  const [selectedType, setSelectedType] = useState<string>(""); // ✅ Default to "Sales"

  const handleOpenModal = () => {
    setShowAppUserModal(true);
    document.body.style.overflow = 'hidden';
  }
  const handleCloseModal = () => {
    setShowAppUserModal(false);
    setmatrialEditData('')
    form.resetFields()
    setSelectedType('')
    document.body.style.overflow = 'visible';
  }
  
return (
    <>
      <div className={`cstmrightmdl ${showAppUserModal && "show"}`}>
        <MatrialDetailsModalView 
        onClose={handleCloseModal} 
        matrialEditData={matrialEditData} 
        form={form} 
        setSelectedType={setSelectedType}
        selectedType={selectedType}
        />
      </div>

        {HasPermission(SideBarMenus.MATERIALDETAIL, 'add') ? (
      <ContentTopBar title={'Material Detail'}
        renderButtons={
          <div className='flex flex-nowrap"'>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              type='primary'
              onClick={handleOpenModal}
              style={{ marginRight: 10 }}
            >
              {'Add Material Detail'}
            </Button>
          </div>
        }
      />
      ):null }
      <ContentFilters formId={formId}>
        <MatrialDetailsViewFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
        />
      </ContentFilters>
    </>
  );
};
